import { user } from './shared/interfaces';

export class data {
     public static products = [];
     public static categories = [];
     public static brands = [];
     public static defaultProductsLimit = 15;
     public static tags = [
          { name: "New", slug: 'new' },
          { name: "Sale", slug: 'sale' },
          { name: "Hot", slug: 'hot' },
          { name: "Sold", slug: 'sold' },
          { name: "Flash Sale", slug: 'flash-sale' },
          { name: "Wholesale", slug: 'wholesale' },
          { name: "Trends", slug: 'trends' },
          { name: "Deal", slug: 'deal' },
          { name: "Original", slug: 'original' },
          { name: "OEM", slug: 'oem' },
          { name: "ODM", slug: 'odm' },
          { name: "Refurbished", slug: 'refurbished' },
          { name: "Used", slug: 'used' },
          { name: "Box Opened", slug: 'boxopened' },
   
     ];
     public static oldqueryParams: any = {};
     public static loggedinuser: user = null;
     public static homeslider = undefined;
     public static storeaddress = '15500 Voss Road, Suite 598 Sugar Land TX 77498 USA';
     public static storeaddressuk = '28 City Road, London EC1V 2NX';
     public static storeemail = 'sales@nanovisiontech.com';
     public static storeemailuk = 'sales@nanovisiontech.co.uk';
     public static storephone = ['+1 832 986 4337'];
     public static storephoneuk = ['+44 747 679 7525'];
     public static storehours = '24/7';
     public static storesdescription =
      'Nanovisiontech is a networked business to provide advanced computers, accessories, components, and networking hardware providers.';
          

     public static searchcategorybyslug(slug) {
          var result;
          for (let index = 0; index < this.categories.length; index++) {
               const element = this.categories[index];
               result = data.walkCategoryTree(element, slug);
               if (result) {
                    return { ...result };
               }
          }
          return result;
     }
     public static walkCategoryTree(element, matchingTitle) {
          if (element.slug == matchingTitle) {
               element.parent = null // required for createing breadcome
               element.items = element.children;
               return element;
          } else if (element.children != null) {
               var i;
               var result = null;
               for (i = 0; result == null && i < element.children.length; i++) {
                    result = data.walkCategoryTree(element.children[i], matchingTitle);
               }
               if (result != null) {
                    result.parent = { name: element.name, slug: element.slug }
               }
               return result;
          }
          return null;
     }
     public static getCategoryChildrenSlugsArray(catSlug) {
          var category = this.searchcategorybyslug(catSlug);
          var result = [];
          function rescursive(cat) {
               result.push(cat.slug);
               if (cat.hasOwnProperty("children")) {
                    for (let index = 0; index < cat.children.length; index++) {
                         const child = cat.children[index];
                         rescursive(child);
                    }
               }
          }
          rescursive(category);
          return result;
     }
     public static searchproductsbycatslug(catSlug) {
          var slugs = this.getCategoryChildrenSlugsArray(catSlug);
          var products = this.products.filter(p => {
               for (let index = 0; index < slugs.length; index++) {
                    const sl = slugs[index];
                    if (p.categories.includes(sl)) {

                         return p;
                    }
               }
          })
          return products;
     }
     public static getProductsByCategory(catSlug: string | null, queryparams: any) {
          var options = this.parsequeryparams(queryparams);

          const page: number = options.page || 1;
          const limit: number = options.limit || this.defaultProductsLimit;
          const sort = options.sort || 'default';

          let items;
          
          var category = null;
          category = this.searchcategorybyslug(catSlug);
          if(category==null){
               catSlug = null;
          }

          if (catSlug != null) {
               items = [...this.searchproductsbycatslug(catSlug)];
          }
          else {
               items = [...this.products];
          }


          // Sort items array.
          items = items.sort((a, b) => {
               if (['name_asc', 'name_desc'].includes(sort)) {
                    if (a.pricesale === b.pricesale) {
                         return 0;
                    }
                    return (a.pricesale > b.pricesale ? 1 : -1) * (sort === 'name_asc' ? 1 : -1);
               }
               return 0;
          });

          const start = (page - 1) * limit;
          const end = start + limit;

          const total = items.length;
          const pages = Math.ceil(total / limit);
          const from = (page - 1) * limit + 1;
          const to = Math.max(Math.min(page * limit, total), from);

          items = [...items.slice(start, end)];


          const filters = [];

          // Make category filters.
          
          if (catSlug === null) {
               filters.push({
                    name: 'Category',
                    //root: true,
                    items: [
                         ...this.categories.map(x => {
                              return { ...x }
                         }),
                    ],
               });
          } else {
               if(category)
               category = { name: category.name, slug: category.slug, parent: category.parent }
               var cat = this.searchcategorybyslug(catSlug)
               if (!cat.hasOwnProperty('children')) {
                    cat.children = []
               }
               var catsfilter = cat.children.map(x => {
                    return { ...x };
               })

               filters.push({
                    name: 'Category',
                    // root: true,
                    items: [
                         ...catsfilter
                    ]
               });
          }
          var pagination = {
               page: page,
               limit: limit,
               total: total,
               pages,
               from,
               to,
               sort,
          }
          var parsedpagination = this.parsepagination(pagination);
          const response = {
               category: category,
               products: items,
               pagination: parsedpagination,
               filters: filters,
          };
          //return timer(350).pipe(map(() => JSON.parse(JSON.stringify(response))));
          return response;
     }
     public static getProductsByBrand(brandslug: string | null, queryparams: any) {
          var options = this.parsequeryparams(queryparams);

          const page = options.page || 1;
          const limit = options.limit || this.defaultProductsLimit;
          const sort = options.sort || 'default';
          let items;
          if (brandslug != null) {
               var brand = this.brands.find(el => el.slug == brandslug);
               items = [...this.products.filter(el => el.brand == brand.name)];
          }
          else {
               items = [...this.products];
          }

          // Sort items array.
          items = items.sort((a, b) => {
               if (['name_asc', 'name_desc'].includes(sort)) {
                    if (a.pricesale === b.pricesale) {
                         return 0;
                    }
                    return (a.pricesale > b.pricesale ? 1 : -1) * (sort === 'name_asc' ? 1 : -1);
               }
               return 0;
          });



          const start = (page - 1) * limit;
          const end = start + limit;

          const total = items.length;
          const pages = Math.ceil(total / limit);
          const from = (page - 1) * limit + 1;
          const to = Math.max(Math.min(page * limit, total), from);

          items = [...items.slice(start, end)];

          const filters = [];


          var pagination = {
               page: page,
               limit: limit,
               total: total,
               pages,
               from,
               to,
               sort,
          }
          var parsedpagination = this.parsepagination(pagination);
          const response = {
               products: items,
               pagination: parsedpagination,
               filters: filters,
          };
          return response;
     }
     public static getProductsByTag(tagslug: string | null, queryparams: any) {
          var options = this.parsequeryparams(queryparams);
          const page = options.page || 1;
          const limit = options.limit || this.defaultProductsLimit;
          const sort = options.sort || 'default';
          let items;
          if (tagslug == null) {
               tagslug = "trends"
          }
          var tag = this.tags.find(el => el.slug == tagslug);
          items = [...this.products.filter(el => el.badge == tag.name)];

          // Sort items array.
          items = items.sort((a, b) => {
               if (['name_asc', 'name_desc'].includes(sort)) {
                    if (a.pricesale === b.pricesale) {
                         return 0;
                    }
                    return (a.pricesale > b.pricesale ? 1 : -1) * (sort === 'name_asc' ? 1 : -1);
               }
               return 0;
          });



          const start = (page - 1) * limit;
          const end = start + limit;

          const total = items.length;
          const pages = Math.ceil(total / limit);
          const from = (page - 1) * limit + 1;
          const to = Math.max(Math.min(page * limit, total), from);

          items = [...items.slice(start, end)];

          const filters = [];


          var pagination = {
               page: page,
               limit: limit,
               total: total,
               pages,
               from,
               to,
               sort,
          }
          var parsedpagination = this.parsepagination(pagination);
          const response = {
               products: items,
               pagination: parsedpagination,
               filters: filters,
          };
          return response;
     }
     public static parsequeryparams(queryparams) {
          var parsedqueryparams: { page: number, limit: number, sort: string } = { page: 1, limit: 15, sort: 'default' };
          if (queryparams.page == null || queryparams.page == undefined || queryparams.page == "") {
          }
          else {
               if (typeof queryparams.page === "string") {
                    parsedqueryparams.page = parseInt(queryparams.page)
               }
               else {
                    parsedqueryparams.page = queryparams.page
               }
          }

          if (queryparams.limit == null || queryparams.limit == undefined || queryparams.limit == "") {
          }
          else {
               if (typeof queryparams.limit === "string") {
                    parsedqueryparams.limit = parseInt(queryparams.limit)
               }
               else {
                    parsedqueryparams.limit = queryparams.limit
               }
          }

          if (queryparams.sort == null || queryparams.sort == undefined || queryparams.sort == "") {
          }
          else {
               parsedqueryparams.sort = queryparams.sort
          }
          if(Object.keys(this.oldqueryParams).length!=0){
               if(this.oldqueryParams.sort!=parsedqueryparams.sort){
                    parsedqueryparams.page = 1;
               }
               if(this.oldqueryParams.limit!=parsedqueryparams.limit){
                    parsedqueryparams.page = 1;
               }
          }
          this.oldqueryParams = parsedqueryparams;
          return parsedqueryparams;
     }
     public static parsepagination(pagination) {
          var parsedpagination: {
               page: number,
               limit: number,
               total: number,
               pages: number,
               from: number,
               to: number,
               sort: string
          } = {page: 1,
               limit: 15,
               total: 15,
               pages: 1,
               from: 0,
               to: 15,
               sort: 'default'};

          parsedpagination.page = (typeof pagination.page == "string") ? parseInt(pagination.page) : pagination.page;
          parsedpagination.limit = (typeof pagination.limit == "string") ? parseInt(pagination.limit) : pagination.limit;
          parsedpagination.total = (typeof pagination.total == "string") ? parseInt(pagination.total) : pagination.total;
          parsedpagination.pages = (typeof pagination.pages == "string") ? parseInt(pagination.pages) : pagination.pages;
          parsedpagination.from = (typeof pagination.from == "string") ? parseInt(pagination.from) : pagination.from;
          parsedpagination.to = (typeof pagination.limit == "string") ? parseInt(pagination.to) : pagination.to;
          parsedpagination.sort = pagination.sort;
          return parsedpagination;
     }


}
